import { Card, Skeleton } from "@gearbox-protocol/ui-kit";

export function SkeletonProposalCard() {
  return (
    <Card className="flex flex-col">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-4">
          {/* Hash skeleton */}
          <Skeleton className="h-4 w-20" />
          {/* Name skeleton */}
          <Skeleton className="h-5 w-32" />
        </div>
        <div className="flex items-center gap-4">
          {/* Actions count skeleton */}
          <Skeleton className="h-4 w-16" />
          {/* Timestamp skeleton */}
          <Skeleton className="h-4 w-24" />
          {/* Button skeleton */}
          <Skeleton className="h-8 w-20" />
          {/* Chevron skeleton */}
          <Skeleton className="h-4 w-4" />
        </div>
      </div>
    </Card>
  );
}
